(ns ycweb.app.website.school.courses.list
  (:require
   [ycweb.components.flow :as flow]
   [rum.core :as rum]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.app.website.school.common :as school.common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.headings :as headings]
   [ycweb.util.urlstate :as urlstate]
   [ycweb.app.website.website :as website]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.common :as cmn]))

(rum/defc available-courses < rum/reactive [app-atom]
  (urlstate/redirect app-atom "cooking-school"))

(defmethod flow/render-screen :web.cooking-school/available-courses [app-atom _]
  (website/screen-wrapper app-atom
    (available-courses app-atom)
    {:pagetype :school}))

(defmethod t/transition-open :web.cooking-school/available-courses [app-atom _ _]
  (toaster/open-overlay app-atom :web.cooking-school/courses)
  (comms/ajax-get :web.cooking-school/available-courses {}))

(defmethod comms/receive :web.cooking-school/available-courses [app-atom e]
  (toaster/close-overlay app-atom :web.cooking-school/courses)
  (swap!
    (cmn/action-cursor app-atom) assoc
    :courses (:courses e)))
